import { IconButton } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear';
import React from 'react'

function DemoStep4() {
  return (
    <>
      <div className="form">
        <div className="gap_p">
          <div className="control_group w_100">
            <h3 className='hd_6'>Upload Sample Product Images <span>(3-5 Images) (Maximum file size: 5 MB)</span></h3>
            <div className="gap_p">
              <div className="control_group w_33">
                <div className="upload_box">
                  <label className='upload_action'>
                    <input type="file" />
                    <p>
                      <img src="/static/images/upload_icon.svg" alt='icon' />
                      <strong>Click to upload or drag and drop</strong>
                    </p>
                  </label>
                </div>
              </div>
              <div className="control_group w_33">
                <div className="uploaded_images">
                  <div className="inner ">
                      <figure><img src="/static/images/attachment_06.jpg" alt='uploaded Image' /> <IconButton className="btn_rounded"><ClearIcon /></IconButton></figure>
                  </div>
                </div>
              </div>
              <div className="control_group w_33">
                <div className="uploaded_images">
                  <div className="inner ">
                      <figure><img src="/static/images/attachment_06.jpg" alt='uploaded Image' /> <IconButton className="btn_rounded"><ClearIcon /></IconButton></figure>
                  </div>
                </div>
              </div>
              <div className="control_group w_33">
                <div className="uploaded_images">
                  <div className="inner ">
                      <figure><img src="/static/images/attachment_06.jpg" alt='uploaded Image' /> <IconButton className="btn_rounded"><ClearIcon /></IconButton></figure>
                  </div>
                </div>
              </div>
              <div className="control_group w_33">
                <div className="uploaded_images">
                  <div className="inner ">
                      <figure><img src="/static/images/attachment_06.jpg" alt='uploaded Image' /> <IconButton className="btn_rounded"><ClearIcon /></IconButton></figure>
                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
    </>
  )
}

export default DemoStep4